import React, { useEffect, useState } from "react";
import "./Layout.scss";
import logo from "../../assets/images/I_Own_It_logo.png";
import {
  DesktopOutlined,
  FileOutlined,
  LogoutOutlined,
  PieChartOutlined,
  UserOutlined,
  ReadOutlined,
  MenuUnfoldOutlined,
} from "@ant-design/icons";
import { Button, Drawer, Layout, Menu, Popconfirm, theme } from "antd";
import { useLocation, NavLink, useNavigate } from "react-router-dom";
const { Header, Content, Sider } = Layout;

const useScreenWidth = () => {
  const [screenWidth, setScreenWidth] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return screenWidth;
};

function getItem(label, key, icon, path, children) {
  return {
    key,
    icon,
    children,
    label: path ? <NavLink to={path}>{label}</NavLink> : label,
    path,
  };
}

const items = [
  getItem("Dashboard", "1", <PieChartOutlined />, "/dashboard"),
  getItem("Manage Topics", "2", <PieChartOutlined />, null, [
    getItem("Topics", "21", null, "/manage-topics"),
    getItem("Trending Products", "22", null, "/trending-products"),
    getItem("Popular Categories", "23", null, "/popular-categories"),
    getItem("Recent Searches", "24", null, "/recent-searches"),
  ]),
  getItem("Orders", "3", <DesktopOutlined />, "/orders"),
  getItem("Manage Products", "4", <UserOutlined />, null, [
    getItem("Products", "41", null, "/manage/products"),
    getItem("Categories", "42", null, "/manage/category"),
    getItem("GST & HSN", "43", null, "/gst-hsn"),
  ]),
  getItem("Customers", "5", <FileOutlined />, "/customers"),
  getItem("Blogs", "6", <ReadOutlined />, "/manage/blogs"),
];

const UseLayout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { pathname } = location;
  const [collapsed, setCollapsed] = useState(false);
  const [openKeys, setOpenKeys] = useState([]);
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  const screenWidth = useScreenWidth();

  const findSelectedKey = (items) => {
    for (const item of items) {
      if (item.path === pathname) {
        return item.key;
      }
      if (item.children) {
        const childKey = findSelectedKey(item.children);
        if (childKey) return childKey;
      }
    }
    return null;
  };

  const findOpenKeys = (items, currentPath, parents = []) => {
    for (const item of items) {
      if (item.path === currentPath) {
        return parents;
      }
      if (item.children) {
        const found = findOpenKeys(item.children, currentPath, [
          ...parents,
          item.key,
        ]);
        if (found) return found;
      }
    }
    return [];
  };

  useEffect(() => {
    const initialOpenKeys = findOpenKeys(items, pathname);
    setOpenKeys(initialOpenKeys);
  }, [pathname]);

  const selectedKey = findSelectedKey(items);

  const handleDashboard = () => {
    navigate("/dashboard");
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };

  return (
    <Layout className="layout">
      {screenWidth > 768 ? (
        <Sider
          collapsible
          collapsed={collapsed}
          onCollapse={(value) => setCollapsed(value)}
        >
          <div className="logo" onClick={handleDashboard}>
            <img src={logo} alt="logo" />
          </div>
          <Menu
            theme="dark"
            mode="inline"
            items={items}
            selectedKeys={[selectedKey]}
            openKeys={openKeys}
            onOpenChange={(keys) => {
              const latestOpenKey = keys.find((key) => !openKeys.includes(key));
              const rootSubmenuKeys = items
                .filter((item) => item.children)
                .map((item) => item.key);

              if (rootSubmenuKeys.includes(latestOpenKey)) {
                setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
              } else {
                setOpenKeys(keys);
              }
            }}
            // onOpenChange={(keys) => setOpenKeys(keys)}
            // defaultOpenKeys={["1", "2"]}
          />
        </Sider>
      ) : (
        <Drawer
          title="Menu"
          placement="left"
          closable
          onClose={() => setCollapsed(false)}
          open={collapsed}
          width={250}
        >
          <Menu
            theme="dark"
            mode="inline"
            items={items}
            selectedKeys={[selectedKey]}
            openKeys={openKeys}
            onOpenChange={(keys) => {
              const latestOpenKey = keys.find((key) => !openKeys.includes(key));
              const rootSubmenuKeys = items
                .filter((item) => item.children)
                .map((item) => item.key);

              if (rootSubmenuKeys.includes(latestOpenKey)) {
                setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
              } else {
                setOpenKeys(keys);
              }
            }}
          />
        </Drawer>
      )}
      <Layout>
        <Header
          className="header"
          style={{
            padding: 0,
            background: colorBgContainer,
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          {screenWidth < 768 && (
            <div className="logo" onClick={handleDashboard}>
              <img src={logo} alt="logo" />
            </div>
          )}
          <Popconfirm
            title="Are you sure you want to log out?"
            onConfirm={handleLogout}
            okText="Yes"
            cancelText="No"
          >
            <Button
              type="text"
              icon={<LogoutOutlined />}
              style={{ fontWeight: 600 }}
            >
              Log Out
            </Button>
          </Popconfirm>
        </Header>
        <Content className="layout_main">
          <div className="layout_container">
            {screenWidth < 768 && (
              <>
                <Button
                  type="text"
                  icon={<MenuUnfoldOutlined />}
                  onClick={() => setCollapsed(true)}
                  style={{
                    position: "absolute",
                    top: 15,
                    left: 15,
                    zIndex: 1000,
                  }}
                />
              </>
            )}
            <div className="layout_container_child">{children}</div>
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default UseLayout;
